import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import LeftArrow from "../assets/images/committee/ArrowLeft.svg";

import { useNavigate, useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import PurchaseTicket from "../components/events/PurchaseTicket";
import ReserveTicket from "../components/events/ReserveTicket";
import { api_paths } from "../config/api.paths";
import API from "../config/axios";
import { SET_LOADING } from "../redux/user";

import calendarimg from "../assets/images/icons/calendar.svg";
import clockimg from "../assets/images/icons/clock.svg";
import locationimg from "../assets/images/icons/location.svg";
import capacityimg from "../assets/images/icons/capacity.svg";
import ShareModal from "../components/common/ShareModal";
import PurchasedTickets from "../components/events/PurchasedTickets";
import { RxShare1 } from "react-icons/rx";
// import { Helmet } from "react-helmet";
import { formatEventDate } from "../utils/formatEventDate";

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

const EventDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.USER_DATA);
  const dispatch = useDispatch();
  const [isLoggedIn, setLoggedIn] = useState(false);

  const [eventData, setEventData] = useState(null);
  const [showShare, setShowShare] = useState(false);

  const [purchasedTickets, setPurchasedTickets] = useState([]);
  const [purchasedHolderIds, setPurchasedHolderIds] = useState(new Set());
  const token = localStorage.getItem("GSTB_token");

  useEffect(() => {
    if (user) {
      setLoggedIn(true);
    }
  }, [user]);

  // Fetch Event Details
  const fetchEventDetail = async () => {
    try {
      dispatch(SET_LOADING(true));
      const res = await API.get(
        `${api_paths.member.EVENTS.EVENT_PAGE.EVENT_DETAIL}/${id}`
      );
      setEventData(res?.data?.payload?.result);
    } catch (error) {
      console.error("Error fetching event:", error);
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  const fetchPurchasedTickets = async (evtId = id) => {
    if (!evtId || !token) {
      setPurchasedTickets([]);
      setPurchasedHolderIds(new Set());
      return;
    }
    try {
      dispatch(SET_LOADING(true));
      const res = await API.get(
        `${api_paths.member.EVENTS.PURCHASED_TICKETS}/${evtId}`,
        {
          params: { page: 1, limit: 200 },
        }
      );
      const tickets = res?.data?.payload?.result?.data || [];

      setPurchasedTickets(tickets);
      const holderIds = new Set();
      tickets.forEach((t) => {
        if (t.member_id) holderIds.add(t.member_id);
        if (t.family_member_id) holderIds.add(t.family_member_id);
      });
      setPurchasedHolderIds(holderIds);
    } catch (err) {
      console.error("Fetch purchased tickets (EventDetail) error:", err);
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  // Convert HH:mm → 12-hour format
  const to12Hour = (time) => {
    if (!time || time === "00:00" || time === "null" || time === "undefined") {
      return "TBD";
    }

    const [hour, minute] = time.split(":");
    const dt = new Date();
    dt.setHours(hour, minute);

    if (isNaN(dt.getTime())) return "TBD";

    return dt.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  // Derived Values (clean & centralized)
  // const safeFormatDate = (dateStr) => {
  //   if (
  //     !dateStr ||
  //     dateStr === "null" ||
  //     dateStr === "undefined" ||
  //     dateStr.trim() === ""
  //   ) {
  //     return "TBD";
  //   }

  //   const parsed = new Date(dateStr);
  //   if (isNaN(parsed.getTime())) return "TBD";

  //   return formatToUSDate(dateStr);
  // };

  // const startDate = safeFormatDate(eventData?.start_date);
  // const endDate = safeFormatDate(eventData?.end_date);

  // const isSameDay =
  //   startDate !== "TBD" &&
  //   endDate !== "TBD" &&
  //   eventData.start_date === eventData.end_date;

  const startTime = to12Hour(eventData?.start_time);
  const endTime = to12Hour(eventData?.end_time);

  const timeDisplay =
    startTime !== "TBD" && endTime !== "TBD"
      ? `${startTime} ~ ${endTime}`
      : startTime !== "TBD"
      ? startTime
      : "TBD";

  const venueDisplay = eventData?.venue || "TBD";
  const capacityDisplay =
    eventData?.capacity_type === "limited"
      ? eventData?.seat_limit
        ? `${eventData.seat_limit} seats`
        : eventData?.capacity_type
      : eventData?.capacity_type || "TBD";

  // const eventEndOrStart = eventData?.end_date || eventData?.start_date;
  // const isPastEvent = eventEndOrStart
  //   ? new Date(eventEndOrStart) < new Date()
  //   : false;

  // Check URL params for payment status
  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   const status = params.get("status");
  //   const convergeId = params.get("converge_transaction_id");

  //   if (status) {
  //     setPaymentStatus({ status, convergeId });
  //   }
  // }, [location]);

  // // Handle closing the modal and cleaning the URL
  // const handleCloseModal = () => {
  //   setPaymentStatus(null);
  //   navigate(`/events/${id}`, { replace: true });
  // };

  // const handleRedirect = () => {
  //   setPaymentStatus(null);
  //   // Remove query params from URL without reloading
  //   navigate("/event-ticket", { replace: true });
  // };

  // Effects
  useEffect(() => {
    fetchEventDetail();
    fetchPurchasedTickets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const shareLink =
    eventData?._id && typeof window !== "undefined"
      ? `${window.location.origin}/events/${eventData._id}`
      : "";

  if (!eventData) {
    return <Container className="py-5">Loading...</Container>;
  }

  return (
    // <>
    //   <Helmet>
    //     <title>{eventData?.title || "Event Details"}</title>
    //     <meta name="description" content={eventData?.description || ""} />

    //     {/* Open Graph / Facebook / LinkedIn / WhatsApp */}
    //     <meta property="og:title" content={eventData?.title || ""} />
    //     <meta
    //       property="og:description"
    //       content={eventData?.description || ""}
    //     />
    //     <meta
    //       property="og:image"
    //       content={`${IMAGE_BASEURL}${eventData?.image_path}`}
    //     />
    //     <meta
    //       property="og:url"
    //       content={`${window.location.origin}/events/${eventData?._id}`}
    //     />
    //     <meta property="og:type" content="website" />

    //     {/* Twitter / X */}
    //     <meta name="twitter:card" content="summary_large_image" />
    //     <meta name="twitter:title" content={eventData?.title || ""} />
    //     <meta
    //       name="twitter:description"
    //       content={eventData?.description || ""}
    //     />
    //     <meta
    //       name="twitter:image"
    //       content={`${IMAGE_BASEURL}${eventData?.image_path}`}
    //     />
    //   </Helmet>

    <Container className="py-4">
      {/* Render the Modal if status exists */}
      {/* {paymentStatus && (
          <PaymentStatusModal
            status={paymentStatus?.status}
            convergeId={paymentStatus?.convergeId}
            onClose={handleCloseModal}
            onNavigate={handleRedirect}
            buttonName={"event"}
            type={"event"}
          />
        )} */}

      {/* BACK BUTTON */}
      <Row className="mb-4">
        <Col>
          <img
            onClick={() => navigate(-1)}
            className="cursor-pointer"
            src={LeftArrow}
            alt="back"
          />
        </Col>
      </Row>

      <Row className="gy-4">
        {/* LEFT */}
        <Col md={12} lg={8}>
          {/* IMAGE */}
          <img
            src={`${IMAGE_BASEURL}${eventData?.image_path}`}
            alt="Event"
            style={{
              width: "100%",
              height: "500px",
              objectFit: "cover",
              borderRadius: "12px",
            }}
            className="mb-4 eventdetails-img"
          />
          {/* TITLE + ACTIONS */}
          <Row className="align-items-center mb-2">
            <Col>
              <h3 className="fw-bold text-main mb-0">{eventData.title}</h3>
            </Col>
            <Col xs="auto" className="d-flex align-items-center gap-3">
              <RxShare1
                onClick={(e) => {
                  e.stopPropagation(); // prevent card navigation
                  setShowShare(true);
                }}
                size={22}
                style={{ color: "#77787B", cursor: "pointer" }}
              />
              {/* <Button className="py-2 px-4 btn btn-black">
                {isPastEvent ? "View" : "RSVP"}
              </Button> */}
            </Col>
          </Row>

          {/* PRICE */}
          {eventData.price && (
            <div className="ticket-price mb-2 fw-medium f-16">
              <>
                <div className="event-overlay-price mb-2">
                  Non-Members ${Number(eventData.price).toFixed(2)}
                </div>
                {/* <br /> */}
                <div className="event-overlay-member-price mb-3">
                  {user?.member_price
                    ? ` ${new Date(
                        eventData?.start_date
                      ).getFullYear()} Members: ${user?.member_price}`
                    : `Free to ${new Date(
                        eventData?.start_date
                      ).getFullYear()} Members`}
                </div>
              </>
            </div>
          )}

          {/* DESCRIPTION */}
          <p>{eventData.description}</p>
          {/* DATE & TIME */}
          <Row className="mt-5">
            {/* Event Date */}
            <Col xs={6} md={6}>
              <Row className="d-flex align-items-center">
                <Col sx={3} md={2} xl={2} className="pe-lg-0">
                  <div className="subevent-icon-circle">
                    <img
                      src={calendarimg}
                      alt="calendar"
                      className="dashboard-card-icon"
                    />
                  </div>
                </Col>

                <Col
                  sx={9}
                  md={10}
                  xl={10}
                  className="ps-lg-0 subevent-details"
                >
                  <p className="fw-normal mb-0 subevent-title">Event Date</p>
                  {/* <p className="fw-semibold mb-0">
                      {isSameDay
                        ? startDate
                        : startDate !== "TBD" && endDate !== "TBD"
                        ? `${startDate} - ${endDate}`
                        : "TBD"}
                    </p> */}
                  <p className="fw-semibold mb-0">
                    {formatEventDate(eventData)}
                  </p>
                </Col>
              </Row>
            </Col>

            {/* Event Time */}
            <Col xs={6} md={6}>
              <Row className="d-flex align-items-center">
                <Col sx={3} md={2} xl={2} className="pe-lg-0">
                  <div className="subevent-icon-circle">
                    <img
                      src={clockimg}
                      alt="clock"
                      className="dashboard-card-icon"
                    />
                  </div>
                </Col>

                <Col
                  sx={9}
                  md={10}
                  xl={10}
                  className="ps-lg-0 subevent-details"
                >
                  <p className="fw-normal mb-0 subevent-title">Event Time</p>
                  <p className="fw-semibold mb-0">{timeDisplay}</p>
                </Col>
              </Row>
            </Col>
          </Row>
          {/* LOCATION & CAPACITY */}
          <Row className="mt-4">
            <Col xs={6} md={6}>
              <Row className="d-flex align-items-center">
                <Col sx={3} md={2} xl={2} className="pe-lg-0">
                  <div className="subevent-icon-circle">
                    <img
                      src={locationimg}
                      alt="location"
                      className="dashboard-card-icon"
                    />
                  </div>
                </Col>

                <Col
                  sx={9}
                  md={10}
                  xl={10}
                  className="ps-lg-0 subevent-details"
                >
                  <p className="fw-normal mb-0 subevent-title">
                    Event Location
                  </p>
                  <p className="fw-semibold mb-0">{venueDisplay}</p>
                </Col>
              </Row>
            </Col>

            <Col xs={6} md={6}>
              <Row className="d-flex align-items-center">
                <Col sx={3} md={2} xl={2} className="pe-lg-0">
                  <div className="subevent-icon-circle">
                    <img
                      src={capacityimg}
                      alt="capacity"
                      className="dashboard-card-icon"
                    />
                  </div>
                </Col>

                <Col
                  sx={9}
                  md={10}
                  xl={10}
                  className="ps-lg-0 subevent-details"
                >
                  <p className="fw-normal mb-0 subevent-title">Capacity</p>
                  <p className="fw-semibold mb-0">{capacityDisplay}</p>
                </Col>
              </Row>
            </Col>
          </Row>
          {/* <Row className="mt-5">
            <Col lg={12}>
              <div className="me-3">Disclaimer:<span>Additional events will be added as we progress into next year as we obtain more  visibility. <br/>
                All events are subject to change without notice. Please contact a committee member   to confirm details</span></div>
            </Col>
          </Row> */}
          <Row className="mt-5">
            <Col lg={12}>
              <div className="disclaimer-box mt-4">
                <h6 className="disclaimer-title text-main f-18 fw-semibold mb-2">
                  Disclaimer:
                </h6>
                <ul className="disclaimer-list ">
                  <li>
                    Additional events will be added as we progress into next
                    year as we obtain more visibility.{" "}
                  </li>
                  <li>
                    All events are subject to change without notice. Please
                    contact a committee member to confirm details
                  </li>
                </ul>
              </div>
            </Col>
          </Row>

          {/* Purchased Tickets Section */}

          {token && (
            <Row className="mt-5" id="purchased-tickets-section">
              <Col lg={12}>
                <PurchasedTickets
                  eventId={id}
                  tickets={purchasedTickets}
                  event={eventData}
                />
              </Col>
            </Row>
          )}
        </Col>

        {/* RIGHT COLUMN */}
        {eventData?.registration_open && (
          <Col md={12} lg={4}>
            {!isLoggedIn ? (
              <PurchaseTicket event={eventData} />
            ) : (
              <ReserveTicket
                event={eventData}
                purchasedHolderIds={purchasedHolderIds}
                onTicketsUpdated={() => fetchPurchasedTickets(eventData?._id)}
              />
            )}
          </Col>
        )}
      </Row>
      <ShareModal
        show={showShare}
        onHide={() => setShowShare(false)}
        link={shareLink}
      />
    </Container>
    // </>
  );
};

export default EventDetail;
